module.exports = __webpack_public_path__ + "static/img/border2_topr.feb049ce.png";